import { render, staticRenderFns } from "./classPhoto.vue?vue&type=template&id=50ffc245&"
import script from "./classPhoto.vue?vue&type=script&lang=js&"
export * from "./classPhoto.vue?vue&type=script&lang=js&"
import style0 from "./classPhoto.vue?vue&type=style&index=0&id=50ffc245&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports